import { render } from "./ProfileChoice.vue?vue&type=template&id=cc9b4f92&scoped=true&ts=true"
import script from "./ProfileChoice.vue?vue&type=script&lang=ts"
export * from "./ProfileChoice.vue?vue&type=script&lang=ts"

import _style_0 from "./ProfileChoice.vue?vue&type=style&index=0&id=cc9b4f92&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-cc9b4f92"]])

export default __exports__